import MyProfile from '../personas/screens/MyProfile.js';

const routes = [
    {
    path: "/my-profile",
    exact: true,
    name: "Mis Datos",
    icon: "nc-icon nc-circle-10",
    component: MyProfile,
    layout: "/admin",
    sidebar: false,
    roleID: 'ALL'
  }

]
  
export default routes;